// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ITrandSchema } from './TrandSchema';

export interface IGetSupplyDemandResponseSchema {
  /** Разница в процентах для спроса **/
  demandDiff?: string;
  /** Тренд изменения спроса рост/падение/без изменения **/
  demandDiffTrand?: EDemandDiffTrand;
  /** Данные для вывода графика спроса **/
  demandTrand: ITrandSchema[];
  /** Название типа рынка **/
  marketType?: EMarketType;
  /** Подробное описание того что происходит с рынком **/
  marketTypeDescription?: string;
  /** Разница в процентах для предложения **/
  supplyDiff?: string;
  /** Тренд изменения предложения рост/падение/без изменения **/
  supplyDiffTrand?: ESupplyDiffTrand;
  /** Данные для вывода графика предложения **/
  supplyTrand: ITrandSchema[];
}
export enum EDemandDiffTrand {
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
export enum EMarketType {
  'Падающий рынок' = 'Падающий рынок',
  'Растущий рынок' = 'Растущий рынок',
  'Рынок замер' = 'Рынок замер',
  'Рынок покупателя' = 'Рынок покупателя',
  'Рынок продавца' = 'Рынок продавца',
  'Нет отрисовки' = 'нет отрисовки',
}
export enum ESupplyDiffTrand {
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
